import { render, staticRenderFns } from "./Rentabiliza.vue?vue&type=template&id=c2fc4c90&scoped=true"
import script from "./Rentabiliza.vue?vue&type=script&lang=js"
export * from "./Rentabiliza.vue?vue&type=script&lang=js"
import style0 from "./Rentabiliza.vue?vue&type=style&index=0&id=c2fc4c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fc4c90",
  null
  
)

export default component.exports